module.exports = __webpack_public_path__ + "static/narwhal-23f89275e394f7995758486cfeb2d7a1.png";